import type { IconData } from '@stacksjs/iconify-core'

export const toggleOff: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M16.5 17.5h-9a5.5 5.5 0 1 1 0-11h9a5.5 5.5 0 1 1 0 11\" opacity=\".5\"/><circle cx=\"7.5\" cy=\"12\" r=\"2.5\" fill=\"currentColor\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default toggleOff
